/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Arbi API
 * OpenAPI spec version: 1.0.0
 */

export type TaskUpdateTextOutcome = typeof TaskUpdateTextOutcome[keyof typeof TaskUpdateTextOutcome] | null;


export const TaskUpdateTextOutcome = {
  sent: 'sent',
  no_reply: 'no_reply',
  replied: 'replied',
  bounced: 'bounced',
  other: 'other',
} as const;
